(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('filterValueAction', filterValueAction);

    function filterValueAction() {
        return {
            restrict: 'EA',
            templateUrl: 'common/components/filter-values-type/actions',
            controller: filterValueActionCtrl,
            controllerAs: 'vm',
            scope: {},
            bindToController: true
        };
    }

    function filterValueActionCtrl($scope) {
        var vm = this,
            filterService = null;
        this.$onInit = function() {
            $scope.listFilterService = $scope.$parent.listFilterService;

            vm.applyFilter = applyFilter;
            vm.cancel = cancel;

            init();
        }

        function init() {
            $scope.listFilterService.sync(vm);
            filterService = $scope.listFilterService.getFilterService();
        }

        function applyFilter() {
            if (filterService.applyFilter()) {
                vm.pageData.filters.searchFilter = {};
                filterService.resetCurrent();
                $scope.listFilterService.refreshGrid(true);
            }
        }

        function cancel() {
            filterService.resetCurrent();
        }
    }
})();